export enum PathEnums {
  Home = '/',
  Login = '/login',
  Signup = '/signup',
  ReportPost = '/report-post',
}
